import { SubscribableCollection } from "./Subscribable";
import { ITag } from "./Models/ITag";
import { Guid } from "./Guid";
export type TagKey = string; // [Guid, string];
export class TagSubscribable extends SubscribableCollection<ITag> {}
